import styled from "styled-components";

export const PageHeader = styled.div`
  margin-bottom: 24px;
  h1 { font-size: 24px; font-weight: 600; color: #014c75; margin: 0 0 8px 0; }
  p { color: #666; margin: 0; font-size: 14px; }
`;

export const EngagementsWrapper = styled.div`
  min-height: 100vh;

  .header-actions {
    display: flex;
    gap: 12px;
    align-items: center;
    margin-bottom: 24px;

    .view-toggle {
      display: flex;
      border: 1px solid #d9d9d9;
      border-radius: 6px;
      overflow: hidden;

      .toggle-btn {
        border: none;
        border-radius: 0;
        padding: 8px 16px;

        &.active {
          background: #01d9a9;
          color: white;
        }
      }
    }
  }

  .metrics-row {
    margin-bottom: 24px;

    .metric-card {
      border-radius: 12px;
      transition: all 0.3s ease;

      &:hover {
        transform: translateY(-2px);
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
      }

      .metric-content {
        display: flex;
        align-items: center;
        gap: 16px;

        .metric-icon {
          width: 56px;
          height: 56px;
          border-radius: 12px;
          display: flex;
          align-items: center;
          justify-content: center;
        }

        .metric-info {
          .metric-value {
            font-size: 28px;
            font-weight: 700;
            color: #014c75;
            margin: 0;
            line-height: 1.2;
          }

          .metric-label {
            font-size: 14px;
            color: #8c8c8c;
            margin: 0;
          }
        }
      }
    }
  }

  .tabs-section {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 8px;
    margin-bottom: 24px;
    flex-wrap: wrap;

    .tab-button {
      border: none;
      background: transparent;
      padding: 8px 20px;
      border-radius: 8px;
      font-weight: 500;
      cursor: pointer;
      transition: all 0.3s ease;

      &.active {
        background: #01d9a9;
        color: white;
      }

      &:hover:not(.active) {
        background: #f0f0f0;
      }
    }
  }

  .filters-section {
    display: flex;
    gap: 12px;
    margin-bottom: 24px;
    flex-wrap: wrap;
  }

  .engagements-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(380px, 1fr));
    gap: 20px;
  }

  .engagement-card {
    border-radius: 12px;
    overflow: hidden;
    transition: all 0.3s ease;

    &:hover {
      box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);
    }

    .card-header {
      display: flex;
      justify-content: space-between;
      align-items: flex-start;
      margin-bottom: 12px;

      .engagement-id {
        font-size: 12px;
        color: #8c8c8c;
        margin-bottom: 4px;
      }

      .engagement-title {
        font-size: 18px;
        font-weight: 600;
        color: #014c75;
        margin: 0;
        cursor: pointer;

        &:hover {
          color: #01d9a9;
        }
      }

      .action-icon {
        font-size: 20px;
        cursor: pointer;
        padding: 4px;
        border-radius: 4px;

        &:hover {
          background: #f0f0f0;
        }
      }
    }

    .card-meta {
      display: flex;
      flex-wrap: wrap;
      gap: 8px;
      margin-bottom: 16px;
    }

    .card-description {
      font-size: 14px;
      color: #595959;
      margin-bottom: 16px;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      overflow: hidden;
    }

    .health-indicators {
      display: flex;
      align-items: center;
      gap: 8px;
      padding: 8px 12px;
      background: #fafafa;
      border-radius: 6px;
      margin-bottom: 8px;
      
      .health-separator {
        color: #d9d9d9;
        font-weight: 300;
      }

      .health-item {
        display: flex;
        align-items: center;
        gap: 4px;

        .health-label {
          font-size: 12px;
          color: #8c8c8c;
        }
        
        .health-duration-value {
          font-size: 12px;
          font-weight: 600;
          color: #014c75;
        }

        .health-value {
          font-size: 12px;
          font-weight: 600;

          &.good {
            color: #52c41a;
          }

          &.warning {
            color: #faad14;
          }

          &.critical {
            color: #ff4d4f;
          }
        }
      }
    }

    .card-footer {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding-top: 12px;
      border-top: 1px solid #f0f0f0;

      .budget-info {
        font-size: 13px;
        color: #595959;

        .budget-value {
          font-weight: 600;
          color: #014c75;
        }
      }

      .dates-info {
        font-size: 12px;
        color: #8c8c8c;
      }
    }
  }

  .empty-card {
    grid-column: 1 / -1;
  }
`;

export const EngagementTableWrapper = styled.div`
  .ant-table {
    border-radius: 8px;
    overflow: hidden;
  }

  .engagement-title-link {
    color: #014c75;
    font-weight: 500;
    cursor: pointer;

    &:hover {
      color: #01d9a9;
    }
  }

  .health-badge {
    display: inline-flex;
    align-items: center;
    gap: 4px;
    padding: 2px 8px;
    border-radius: 4px;
    font-size: 12px;
    font-weight: 500;

    &.good {
      background: #f6ffed;
      color: #52c41a;
    }

    &.warning {
      background: #fffbe6;
      color: #faad14;
    }

    &.critical {
      background: #fff2f0;
      color: #ff4d4f;
    }
  }
`;
